<template >
  <b-sidebar :visible="showAliado" :width="widthSidebar" no-close-on-backdrop backdrop @hidden="cerrar()">

    <template #title>
      <h3>{{ getLegendTitle }} </h3>
    </template>

    <b-container fluid>
      <b-row>

        <b-col cols="12">
          <section class="d-flex justify-content-center mb-2">
            <b-img :src="datos.logotipo" thumbnail style="max-width:450px">
            </b-img>
          </section>
        </b-col>
        <b-col cols="12">

          <table class="table table-sm table-hover  table-responsive w-100 ">
            <tbody>
              <tr v-for="(data, key, index) in datos" :key="index" :class="index ? 'mt-2' : ''">
                <template
                  v-if="!['logotipo', 'id','ciudad_id','estado_id','usuario_id','encargado_id'].includes(key) && data && data !== 'null'">
                  <td>
                    <h5 style="line-height: 10pt;">
                      <span v-if="key === 'direccion'">
                        Dirección
                      </span>

                      <span v-else-if="key === 'descripcion'">
                        Descripción
                      </span>

                      <span v-else-if="key === 'datos_facturacion'">
                        Datos de facturación
                      </span>

                      <span v-else-if="key === 'dias_laborables'">
                        Días laborables
                      </span>

                      <span v-else-if="key === 'dias_deuda'">
                        Días de deuda
                      </span>


                      <span v-else-if="key === 'telefono'" class="text-capitalize">
                        Teléfono
                      </span>
                      <span v-else class="text-capitalize">
                        {{ key }}
                      </span>

                    </h5>
                  </td>
                  <td>

                    <section v-if="key === 'precios'" class="d-flex flex-column">
                      <span>
                        <font-awesome-icon icon="fas fa-users-line" />
                        Adulto:{{ data['adulto'] | currency }} MXN
                      </span>

                      <span>
                        <font-awesome-icon icon="fas fa-children" />
                        Menor:{{ data['menor'] | currency }} MXN
                      </span>

                      <span>
                        <font-awesome-icon icon="fas fa-baby" />
                        Infante:{{ data['infante'] | currency }} MXN
                      </span>
                    </section>

                    <section v-else-if="key === 'ciudad'">
                      <span>
                        {{ data.ciudad }}
                      </span>
                    </section>

                    <section v-else-if="key == 'estado'">
                      <span>
                        {{ data.estado }}
                      </span>
                    </section>

                    <section v-else-if="key == 'facturar'">
                      <span>
                        {{ data ? 'Sí' : 'No' }}
                      </span>
                    </section>

                    <section v-else-if="key === 'activo'">
                      <span>
                        {{ data ? 'Sí' : 'NO'}}
                      </span>
                    </section>

                    <section v-else-if="key === 'dias_laborables'">
                      <span>
                        {{ getDias(data) }}
                      </span>
                    </section>

                    <section v-else-if="key === 'dias_deuda'">
                      <span>
                        {{ data }} Días
                      </span>
                    </section>

                    <section v-else-if="key === 'encargado'">
                      <b-media vertical-align="center">
                        <template #aside>
                          <b-avatar size="32" :src="data.avatar" :text="avatarText(data.nombre)"
                            :variant="`light-primary`"/>
                        </template>

                        <section class="d-flex flex-column">
                          <b-link 
                            class="font-weight-bold d-block text-nowrap">
                            {{ data.nombre }}
                          </b-link>
                          <b-link :href="`mailto:${data.email}`" v-if="data.email" target="_blank">
                            <b>{{ data.email }}</b>
                          </b-link>

                          <b-link :href="`tel:${data.telefono}`" v-if="data.telefono">
                            <b>{{ data.telefono }}</b>
                          </b-link>

                        </section>

                      </b-media>
                    </section>

                    <section v-else-if="key === 'choferes'" >
                      <b-avatar-group size="32">
                        <b-avatar v-for="(chofer,r) in data" :key="r" :src="chofer.imagen" :title="chofer.nombre" v-b-tooltip.hover>
                        </b-avatar>
                      </b-avatar-group>

                      <span>
                        {{ data.map(v => v.nombre).toString() }}
                      </span>
                    </section>

                    <section v-else-if="key === 'empleados'" >
                      <b-avatar-group size="32">
                        <b-avatar v-for="(chofer,r) in data" :key="r" :src="chofer.imagen" :title="chofer.nombre" v-b-tooltip.hover>
                        </b-avatar>
                      </b-avatar-group>

                      <span v-if="data.length" >
                        {{ data.map(v => v.nombre).toString() }}
                      </span>

                      <span v-else> Sin Empleados</span>
                      
                    </section>



                    <section v-else-if="key === 'datos_facturacion'">
                      <ul>
                        <li v-for="(d,k,y) in data" :key="y">
                          <b class="text-capitalize" style="line-height: 8pt;">
                            {{ k }} : {{ d ?? 'S/D' }}
                          </b>
                        </li>
                      </ul>
                    </section>



                    <b-card-text v-else>
                      {{ data }}
                    </b-card-text>


                  </td>
                </template>

              </tr>
            </tbody>
          </table>
        </b-col>
      </b-row>
    </b-container>

  </b-sidebar>
</template>

<script>

import {toRefs,ref,computed,onMounted,inject} from 'vue'
import store from '@/store'
import { avatarText } from '@core/utils/filter'

import {
  BSidebar,
  BCard,
  BContainer,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BCardText,
  BImg,
  BMedia,
  BAvatar,
  BAvatarGroup,
  VBTooltip,
  BLink

} from 'bootstrap-vue';

import { getDay } from '@core/utils/utils';

export default {
  
  props:{
    datos:{
      type:Object,
      default:{
        nombre: '',
        encargado_id: null,
        empleados: [],
        precios: {
          adulto: 0,
          menor: 0,
          infante: 0
        },
        logotipo: null,
        telefono: null,
        email: null,
        sitio_web: null,
        direccion: '',
        lat: 20.6565177,
        lng: -105.211358,
        ciudad_id: null,
        estado_id: null,
        activo: false,
        descripcion: '',
        persona_contacto: null,
        seg_telefono: null,
        breve: '',
        codigo_postal: null,
        usuario_id: null,
        ciudad: null,
        estado: null,
        usuario: null,
        facturar: false,
        datos_facturacion: null,
        horario_trabajo: null,
        dias_laborables: [],
        visitas: [],
        choferes: [],
      }
    },
    
    aliadoType:{
      type:Number,
      default:1, // 1 => Agencia, 2 => Negocio, 3 => proveedor, 4 => Transportistas
    },
    showAliado:Boolean,
    actions:Function
  },

  model:{
    prop:'showAliado',
    event:'update:showAliado'
  },

  components:{
    BSidebar,
    BCard,
    BContainer,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BCardText,
    BImg,
    BMedia,
    BAvatar,
    BLink,
    BAvatarGroup
  },

  directives:{
    'b-tooltip': VBTooltip
  },

  setup(props) {

    const {actions,aliadoType} = toRefs(props)
    const {windowWidth} = toRefs(store.state.app)
    
    const {
      clearDatos,
      cerrar,
      setDatoAliado,
      setTypeAliado
    } = actions.value();

    const getLegendTitle = computed(() => {
      let legends = ['Datos de la agencia','Datos del negocio', 'Datos del proveedor','Datos del Transportista'];
      return legends[aliadoType.value - 1];
    })

    const widthSidebar = computed(() => {

      if(windowWidth.value > 1200){
        return '1100px';
      }else if(windowWidth.value > 992){
        return '982px';
      }
      else if (windowWidth.value > 768) {
        return '668px';
      } else if (windowWidth.value > 576) {
        return '476px';
      } else{
        return '320px';
      }
    })

    const getDias = (days) => {
      let dias = [];

      days.forEach(d => {
        dias.push(getDay(d))
      })

      return dias.toString()
    }

    return {
      loading:computed(() => store.state.loading),
      windowWidth,
      clearDatos,
      cerrar,
      setDatoAliado,
      setTypeAliado,
      getLegendTitle,
      widthSidebar,
      getDias,
      avatarText

    }
  },
}
</script>